// (function ($) {
//     $(window).on('load', function () {
//         var research = '.header .we-left-nav .research > a'
//         var commentary = '.header .we-left-nav .commentary > a'
//         var resParam = $(research).text();
//         var comParam = $(commentary).text();
//         $(research).parent().find('.mega-menu .right-part li a').each(function () {
//             $(this).on('click', function () {
//                 var href = window.location.href + '?' + resParam;
//             });
//         });
//     });
// })(jQuery);
// 